import { render } from "./event-info.vue?vue&type=template&id=11249b6a&scoped=true"
import script from "./event-info.vue?vue&type=script&lang=js"
export * from "./event-info.vue?vue&type=script&lang=js"

import "./event-info.vue?vue&type=style&index=0&id=11249b6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11249b6a"]])

export default __exports__